"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyFactory = void 0;
const mnemonic_1 = require("../key/mnemonic");
/**
 * The factory to provide an instance of master key generator.
 * Usage: KeyFactory.getInstance(), returns a default instance of Mnemoic key generator
 */
class KeyFactory {
    /**
     * Get an instance of the key manager to generate/validate keys.
     * Default will be mnemonic-key manager
     * @returns
     */
    static getInstance() {
        return new mnemonic_1.MnemonicKey();
    }
}
exports.KeyFactory = KeyFactory;
